export const portfolioSettingDrawer = {
    xSelect1: 'Score (Technological Progress)',
    ySelect1: 'Market Expectation',
    company: {
        bubbleSelect1: 'Score (Technological Competitiveness)',
        bubbleSelect2: 'Number of Patent Applications',
        bubbleSelect3: 'Average Forward Citations',
        bubbleSelect4: 'Number of Material Patents',
        bubbleSelect5: 'Material Patent rate'
    },
    country: {
        bubbleSelect1: 'Score (Technological Competitiveness)',
        bubbleSelect2: 'Score (Average)',
        bubbleSelect3: 'Number of Patent Applications',
        bubbleSelect4: 'Citations (Total)',
        bubbleSelect5: 'Citations Average (Patent-Based)',
        bubbleSelect6: 'Citations Average (Company-Based)',
        bubbleSelect7: 'Citations (Top-N Average)',
        bubbleSelect8: 'Key Patents',
        bubbleSelect9: 'Key Patent Ratio'
    },
    setting: 'Configuration',
    size: 'Bubble Size',
    bubbleScale: 'Bubble Size Emphasis',
    bubbleSizeLimit: 'Bubble Size Upper Limit',
    xLabel: 'X Axis',
    yLabel: 'Y Axis',
    zoomSlider: 'Zoom Slider',
    labelFixMode: 'Label Fix',
    nonDisplay: 'Do not fix the labels',
    labelClusterId: 'Cluster ID',
    labelClusterName: 'Cluster Name',
    labelBubbleSize: 'Bubble Size',
    initButton: 'Revert to Default'
}
